'use client';

import * as amplitude from '@amplitude/analytics-browser';
import { ampli as generatedAmpli, loadBrowserAmpli } from '@blinq/analytics/browser';
import { getCookieConsentForCategory } from '@modules/cookie-utils';
import { createChildLogger } from '@modules/logger';

const log = createChildLogger({ module: 'analytics/ampli' });
export const AMPLI_PLATFORM = 'dash';

let loadAttempted = false;

function getLoadedAmpli() {
  if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') {
    return null;
  }

  if (!getCookieConsentForCategory('analytics')) {
    return null;
  }

  if (!loadAttempted) {
    loadAttempted = true;
    try {
      loadBrowserAmpli({
        client: {
          instance: amplitude,
        },
      });
    } catch (error) {
      log.warn('Failed to load Ampli analytics', { error });
      return null;
    }
  }

  return generatedAmpli.isLoaded ? generatedAmpli : null;
}

export function trackAmpli(action: (loadedAmpli: typeof generatedAmpli) => void) {
  const loadedAmpli = getLoadedAmpli();

  if (!loadedAmpli) {
    return;
  }

  try {
    action(loadedAmpli);
  } catch (error) {
    log.warn('Failed to track Ampli analytics event', { error });
  }
}
